export const pageNameMap = {
  'econsent-splash-screen': 'econsent',
  'oao-membership': 'membership',
  'oao-eligibility': 'eligibility',
  'oao-application-fields': 'application-fields',
  'oao-application-residential-history': 'residential-history',
  'action-poll-appid': 'generate-appid',
  'oao-employment-history': 'employment-history',
  'oao-add-co-applicant': 'add-co-applicant',
  'oao-application-fields-co-applicant': 'application-fields',
  'oao-application-residential-history-co-applicant': '',
  'oao-employment-history-co-applicant': 'employment-history',
  'oao-add-second-co-applicant': 'add-second-co-applicant',
  'oao-application-fields-additional-co-app': 'application-fields',
  'oao-application-residential-history-additional-co-app': 'residential-history',
  'oao-employment-history-additional-co-app': 'employment-history',
  'oao-application-checkpoint': 'checkpoint',
  'oao-additional-accounts': 'additional-accounts',
  'oao-beneficiary': 'beneficiary',
  'oao-additional-information': 'additional-information',
  'oao-requested-document': 'requested-document',
  'oao-identity': 'identity',
  'oao-alloy-verification': 'alloy-verification',
  'oao-application-review': 'application-review',
  'oao-application-fields-youth': 'application-fields',
  'oao-employment-history-youth': 'employment-history',
  'oao-business-info': 'business-info',
  'oao-business-application-fields-#': 'application-fields',
  'oao-responsible-party-resident-#': 'residential-history',
  'oao-responsible-party-employment-history-#': 'employment-history',
  'oao-beneficial-owner-#': 'owner',
  'oao-beneficial-resident-#': 'residential-history',
  'oao-beneficial-employment-history-#': 'employment-history',
  'oao-business-auth-signers-application-fields-#': 'application-fields',
  'oao-auth-signer-resident-#': 'residential-history',
  'oao-application-checkpoint-business': 'checkpoint',
  'oao-additional-accounts-business': 'additional-accounts',
  'oao-beneficiary-business': 'beneficiary-business',
  'oao-additional-information-business': 'additional-information',
  'oao-bank-secrecy-act': 'bank-secrecy-act',
  'oao-identity-business': 'identity',
  'ola-econsent-splash-screen': 'econsent',
  'ola-consumer-loan-type': 'loan-type',
  'ola-eligibility': 'eligibility',
  'ola-personal-loan-details': 'loan-details',
  'ola-purchase-loan-details': 'loan-details',
  'ola-secure-loan-personal-info': 'personal-info',
  'ola-consumer-residential': 'residential',
  'ola-action-poll-appId': 'generate-appid',
  'ola-employment-history': 'employment-history',
  'ola-add-co-applicant': 'add-co-applicant',
  'ola-secure-loan-co-applicant-#': 'personal-info',
  'ola-consumer-residential-co-borrower-#': 'residential',
  'ola-employment-history-co-borrower-#': 'employment-history',
  'ola-references': 'references',
  'ola-references-co-borrower-#': 'references',
  'ola-consumer-additional-info': 'additional-info',
  'ola-alloy-verification': 'alloy-verification',
  'ola-application-review': 'application-review',
  'ola-new-auto-loan-product': 'new-auto-loan-product',
  'ola-refinance-loan-details': 'loan-details',
  'ola-consumer-personal-info': 'personal-info',
  'ola-consumer-co-applicant-#': 'personal-info', // TODO: this is really an error in ww naming.
  'ola-cc-loan-details': 'loan-details',
  'ola-secured-loan-details': 'loan-details',
  'ola-ploc-loan-details': 'loan-details',
  'ola-heloc-consumer-residential': 'residential',
  'ola-heloc-loan-details': 'loan-details',
  'ola-heloc-demographic-info': 'demographics',
  'ola-heloc-demographic-info-co-borrower-#': 'demographics',
  'instatouch-page': 'instatouch'
};
